import { FiCheckCircle, FiAlertTriangle, FiXCircle } from 'react-icons/fi';

/**
 * Etiquetas de usuario compartidas por el gestor, el detalle y la sidebar.
 * Antes estaban duplicadas en cada pantalla y se desincronizaban.
 */

export const ROL_LABELS = {
  admin: 'Administrador',
  tecnico: 'Técnico',
  user: 'Usuario',
};

export const ESTADO_LABELS = {
  verificar: 'Sin verificar',
  verificado: 'Verificado',
  suspendido: 'Suspendido',
};

export const ESTADO_LABELS_LARGO = {
  verificar: 'Pendiente de verificar',
  verificado: 'Verificada y con acceso',
  suspendido: 'Suspendida por cancelación o impago',
};

export const ESTADO_ICONOS = {
  verificar: FiAlertTriangle,
  verificado: FiCheckCircle,
  suspendido: FiXCircle,
};

export const DEPTO_LABELS = {
  // 'no_asignado' es el valor por defecto del modelo, así que tiene que existir
  // aquí o los selects no encuentran el valor actual del usuario.
  no_asignado: 'Sin asignar',
  no_especificado: 'No especificado',
  desarrollo: 'Desarrollo',
  marketing: 'Marketing',
  diseno: 'Diseño',
  redes_sociales: 'Redes Sociales',
};

// La sidebar rotula el departamento en corto para que quepa en su ancho
export const DEPTO_LABELS_CORTO = {
  desarrollo: 'Desarrollo',
  marketing: 'Marketing',
  diseno: 'Diseño',
  redes_sociales: 'RRSS',
};

export const esStaff = (role) => role === 'admin' || role === 'tecnico';
